<template>
	<div id="results">
		<nk-wrapper v-if="aktuellsteTexte" spacing="lg">
			<nk-list variant="overview">
				<nk-list-item
					v-for="(artikel, index) in aktuellsteTexte"
					:key="`${index}-artikel-${artikel.id}`"
				>
					<article>
						<nk-row vertical-gutter="2">
							<nk-col cols="full" order="2" sm="auto" order-sm="1">
								<nk-meta>
									{{ getDateTimeString({dateFrom: artikel.datum_von}) }}
								</nk-meta>
								<nk-title v-if="disableLinks" max-lines="2" size="lg" tag="h1">
									{{ artikel.titel }}
								</nk-title>
								<nk-link v-else :link="artikel.detailURL" block>
									<nk-title max-lines="2" size="lg" tag="h1">
										{{ artikel.titel }}
									</nk-title>
								</nk-link>
								<nk-text max-lines="3" size="md">
									{{ artikel.einleitung }}
								</nk-text>
								<nk-button
									v-if="!disableLinks"
									:link="artikel.detailURL"
									variant="solid"
									tabindex="-1"
								>
									Weiterlesen
								</nk-button>
							</nk-col>
							<nk-col
								v-if="artikel.bild"
								cols="full"
								order="1"
								sm="4/12"
								order-sm="2"
							>
								<nk-image
									v-if="disableLinks"
									:src="artikel.bild"
									:alt="artikel.bildtext"
									:copyright="artikel.bildcopyright"
									:imgix="{
										'max-h': options.variableImageHeight ? 0 : 512,
									}"
									image-class="w-full"
								/>
								<nk-link v-else :link="artikel.detailURL" tabindex="-1">
									<nk-image
										:src="artikel.bild"
										:alt="artikel.bildtext"
										:copyright="artikel.bildcopyright"
										:ar="options.variableImageHeight ? null : '3:2'"
										image-class="w-full"
									/>
								</nk-link>
							</nk-col>
						</nk-row>
					</article>
				</nk-list-item>
			</nk-list>
		</nk-wrapper>
	</div>
</template>

<script>
import {defineSettings} from '../../composables/component';
import TemplatesDefault from '../../mixins/templates-default';
import {
	useIntranet,
	fetchIntranetAktuellsteTexte,
} from '#nk/composables/intranet';
const settings = defineSettings('NkTemplateArtikelOverview');
/**
 * @prop {object} context
 * @prop {Array} context.articles
 * @prop {Array} context.highlights
 * @prop {object} options
 * @prop {Boolean} options.variableImageHeight
 */

export default {
	name: 'NkTemplateArtikelOverview',

	mixins: [TemplatesDefault],

	async setup() {
		const intranet = useIntranet();
		if (intranet.user.value) await fetchIntranetAktuellsteTexte();

		return {
			settings,
			intranet,
			aktuellsteTexte: intranet.aktuellsteTexte,
		};
	},

	computed: {
		activePageNumber() {
			return Number(this.$route.query.seite) || 1;
		},

		disableLinks() {
			if (this.context.options) {
				return this.context.options.disableLinks;
			}
			return false;
		},
	},

	methods: {
		getDateTimeString(object, dateFormat, timeFormat) {
			return this.$getDateTimeString(object, dateFormat, timeFormat);
		},
	},
};
</script>
